import { PersonPreviewModel } from "../../../models/person";
import { IBaseState } from "../../index";

export interface IPersonDetailState extends IBaseState<{}, {}> {
    personModel?: PersonPreviewModel;
    service?: {};
}

export class PersonDetailState implements IPersonDetailState {
    personModel: PersonPreviewModel;
    service?: {};
    constructor(options: IPersonDetailState) {
        this.personModel = new PersonPreviewModel;
        this.service = options.service;
    }
}